"use client";
import React, { useState, useEffect, useRef } from "react";
import Flickity from "react-flickity-component";
import "./slideshow.css"; // Import Flickity styles

const Slideshow = ({ banners, options }) => {
  const [carousel, setCarousel] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );
  const carouselRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(typeof window !== "undefined" ? window.innerWidth : 0);
    };

    typeof window !== "undefined" &&
      window.addEventListener("resize", handleResize);

    // Cleanup
    return () =>
      typeof window !== "undefined" &&
      window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (carousel) {
      // Initialize Flickity after component mounts
      carousel.flickity();
    }
  }, [carousel]);

  // Assume a mobile breakpoint at 768px
  const isMobile = windowWidth < 768;

  return (
    <div className="hero-carousel-container">
      <Flickity ref={carouselRef} options={options}>
        {banners.map((slide, index ) => (
          <div key={index} className="carousel-cell">
            <img
              src={isMobile ? slide.mobileImageUrl : slide.imageUrl}
              alt={slide.title}
              className="carousel-image"
            />
            <div className="carousel-content">
              <h2 style={{ color: slide.h2col }} className="carousel-title">{slide.title}</h2>
              <p style={{ fontStyle: slide.textdec }} className="carousel-description">{slide.description}</p>
              <div className="slide-icon-cont">
                {slide.icon1 && (
                  <>
                    <img src={slide.icon1} alt={slide.icon1_alt} />
                    <p>{slide.icon1_alt}</p>
                  </>
                )}
                {slide.icon2 && (
                  <>
                    <img src={slide.icon2} alt={slide.icon2_alt} />
                    <p>{slide.icon2_alt}</p>
                  </>
                )}
                {slide.icon3 && (
                  <>
                    <img src={slide.icon3} alt={slide.icon3_alt} />
                    <p>{slide.icon3_alt}</p>
                  </>
                )}
                {slide.icon4 && (
                  <>
                    <img src={slide.icon4} alt={slide.icon4_alt} />
                    <p>{slide.icon4_alt}</p>
                  </>
                )}
                {slide.icon5 && (
                  <>
                    <img src={slide.icon5} alt={slide.icon5_alt} />
                    <p>{slide.icon5_alt}</p>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </Flickity>
    </div>
  );
};

export default Slideshow;
